import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { Popover, PopoverHeader, PopoverBody, Modal, ModalHeader, ModalBody } from 'reactstrap';
import * as types from "../../constants/actionTypes";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import GuestLinkBody from "./GuestLinkBody";

class GuestLinkModal extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        logUI("UI.ShareVideoVisitModalForGuest.ComponentDidMount", new Date(), Tools.getURLPath(), null, this.props.csnIdOfAppointment);
        if (this.props.showModal) {
            logUI("UI.ShareVideoVisitModalForGuest.Displayed", new Date(), Tools.getURLPath(), null, this.props.csnIdOfAppointment);
        }
    }

    closeModal = () => {
        if (this.props.onDismiss) {
            this.props.onDismiss();
        }
        logUI("UI.ShareVideoVisitModalForGuest.Closed", new Date(), Tools.getURLPath(), null, this.props.csnIdOfAppointment);
    }

    onLinkSent = (message, isSuccess) => {
        if (message) {
            const successStatus = isSuccess ? isSuccess : false;
            this.props.setVideoVisitToastrMsg(message, successStatus);
        }

        if (this.props.onLinkSent) {
            this.props.onLinkSent(message, isSuccess);
        }
    }

    render() {
        const { showModal, title, targetId, mainViewContainer, trigger, showModalStyle, guestName, emailOrNumber, participantRole, csnIdOfAppointment } = this.props;
        const modalTitle = title ? title : "Add a Guest";
        const modalHeaderContent = <>{modalTitle} <button type="button" className="btn btn-icon-only" onClick={() => this.closeModal()}><span className="icon-close" /></button></>;

        return (
            <React.Fragment>
                {showModalStyle
                    ? <Modal className="add-guest-modal"
                        centered
                        isOpen={showModal}
                        toggle={this.closeModal}
                    >
                        <ModalHeader>{modalHeaderContent}</ModalHeader>
                        <ModalBody>
                            <GuestLinkBody participantRole={participantRole} guestName={guestName} emailOrNumber={emailOrNumber} csnIdOfAppointment={csnIdOfAppointment}
                                closeModal={() => this.closeModal()} onLinkSent={(message, isSuccess) => this.onLinkSent(message, isSuccess)}
                            />
                        </ModalBody>
                    </Modal>
                    : <Popover className="add-guest-popover"
                        isOpen={showModal} target={targetId ? targetId : "add-guest-btn"} container={mainViewContainer ? mainViewContainer : ".main-view-container"}
                        hideArrow toggle={this.closeModal} trigger={trigger ? trigger : "click"}
                        modifiers={{
                            setPopPosition: {
                                enabled: true,
                                order: 890,
                                fn: (data) => {
                                    return {
                                        ...data,
                                        styles: {
                                            ...data.styles,
                                            overflow: 'auto',
                                            left: 'initial',
                                            top: 'initial',
                                            right: '0px',
                                            bottom: '50px',
                                            position: 'absolute',
                                            transform: 'none',
                                            boxShadow: '-1px 0 3px 0 rgba(0, 0, 0, 0.25)',
                                            borderRadius: '0px',
                                            maxWidth: '500px',
                                            textAlign: 'center',
                                            width: '100%',
                                            zIndex: '9999'
                                        },
                                    };
                                },
                            },
                        }}>
                        <PopoverHeader><span className="svg-patient" />{modalHeaderContent}</PopoverHeader>
                        <PopoverBody>
                            <GuestLinkBody participantRole={participantRole} guestName={guestName} emailOrNumber={emailOrNumber}
                                closeModal={() => this.closeModal()} onLinkSent={(message, isSuccess) => this.onLinkSent(message, isSuccess)}
                                csnId={csnIdOfAppointment}
                            />
                        </PopoverBody>
                    </Popover>
                }
            </React.Fragment>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setVideoVisitToastrMsg: (message, successStatus) => dispatch({ type: types.SET_VIDEO_VISIT_TOASTR_MSG, message, successStatus })
    };
};

export default withRouter(connect(null, mapDispatchToProps)(GuestLinkModal));